/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BookmarkIcon16Regular = forwardRef('BookmarkIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.25 4A2.75 2.75 0 0 1 5 1.25h6A2.75 2.75 0 0 1 13.75 4v10.117a1.25 1.25 0 0 1-1.893 1.072L8 12.875l-3.857 2.314a1.25 1.25 0 0 1-1.893-1.072V4ZM5 2.75c-.69 0-1.25.56-1.25 1.25v9.675l3.607-2.164a1.25 1.25 0 0 1 1.286 0l3.607 2.164V4c0-.69-.56-1.25-1.25-1.25H5Z" })));
});
